import React, { FunctionComponent } from 'react';
import { Box } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

const specificationsFeaturesSingleLoader = <Skeleton animation="wave" height={21} width="100%" />;

const SpecificationsAndFeaturesLoader: FunctionComponent = () => {
  return (
    <Box display="flex" flexDirection="column" width="100%">
      <Box width="100%" pb={5}>
        <Box width="20%">{specificationsFeaturesSingleLoader}</Box>
        {specificationsFeaturesSingleLoader}
        {specificationsFeaturesSingleLoader}
      </Box>
      <Box width="100%" pb={3}>
        <Box width="20%">{specificationsFeaturesSingleLoader}</Box>
        {specificationsFeaturesSingleLoader}
        {specificationsFeaturesSingleLoader}
        {specificationsFeaturesSingleLoader}
      </Box>
    </Box>
  );
};

export default SpecificationsAndFeaturesLoader;
